<template>
  <el-dialog
    title="其他筛选条件"
    :visible.sync="dialogVisible"
    append-to-body
    top="2vh"
    v-loading="loading"
    width="40%"
  >
  <el-form label-width="130px" :model="form">
     <el-form-item label="学制：">
        <el-select v-model="form.schooling_length" style="width: 320px;" placeholder="请选择" size="small">
            <el-option
            label="不限"
            value="">
            </el-option>
            <el-option
            v-for="item in [1,2,3,4,5,6,7,8,9]"
            :key="item"
            :label="item + '年'"
            :value="item">
            </el-option>
        </el-select>
     </el-form-item>
     <el-form-item label="学费范围：">
        <el-input v-model="form.tuition_fee_min" style="width: 150px;" type="number" size="small"></el-input>
        到
        <el-input v-model="form.tuition_fee_max" style="width: 150px;" type="number" size="small"></el-input>

        <el-checkbox v-model="form.tuition_fee_no" style="margin-left: 10px;">含学费未知</el-checkbox>
     </el-form-item>
     <el-form-item label="招生计划数：">
        <el-input v-model="form.planned_number_min" style="width: 150px;" type="number" size="small"></el-input>
        到
        <el-input v-model="form.planned_number_max" style="width: 150px;" type="number" size="small"></el-input>
     </el-form-item>
     <el-form-item label="有无征集：">
        <el-select v-model="form.zhengji" style="width: 320px;" placeholder="请选择" size="small">
            <el-option
            label="不限"
            value="">
            </el-option>
            <el-option
            v-for="item in ['有征集','无征集']"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
        </el-select>
     </el-form-item>
     <el-form-item label="专业含关键字：">
        <el-select 
          v-model="form.specialty_title" 
          style="width: 320px;" 
          placeholder="请选择" 
          size="small"
          multiple
          collapse-tags
        >
            <el-option
            label="不限"
            value="">
            </el-option>
            <el-option
            v-for="item in ['中外合作','专项','预科','八协','少数民族','自定义']"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
        </el-select>
        <el-input 
          v-model="form.specialty_title_other" 
          size="small" 
          v-if="form.specialty_title.includes('自定义')" 
          placeholder="请输入，多个关键词用逗号分隔" 
          style="width: 250px;margin-left: 10px;"
          @input="handleCustomInput('specialty_title_other')"
        ></el-input>
     </el-form-item>
     <el-form-item label="专业不含关键字：">
        <el-select 
          v-model="form.specialty_title_no" 
          style="width: 320px;" 
          placeholder="请选择" 
          size="small"
          multiple
          collapse-tags
        >
            <el-option
            label="默认不推荐"
            value="">
            </el-option>
            <el-option
            v-for="item in ['中外合作','专项','预科','八协','少数民族','自定义']"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
        </el-select>
        <el-input 
          v-model="form.specialty_title_no_other" 
          size="small" 
          v-if="form.specialty_title_no.includes('自定义')" 
          placeholder="请输入，多个关键词用逗号分隔" 
          style="width: 250px;margin-left: 10px;"
          @input="handleCustomInput('specialty_title_no_other')"
        ></el-input>
     </el-form-item>
     <el-form-item label="分数范围">
        <el-input v-model="form.min_score" style="width: 150px;" type="number" size="small"></el-input>
        到
        <el-input v-model="form.max_score" style="width: 150px;" type="number" size="small"></el-input>
     </el-form-item>
     <el-form-item label="是否师范类：">
         <el-radio v-model="form.isShifan" label="0">全部</el-radio>
         <el-radio v-model="form.isShifan" label="1">师范类</el-radio>
         <el-radio v-model="form.isShifan" label="2">非师范类</el-radio>
     </el-form-item>
     <el-form-item label="是否新专业：">
         <el-radio v-model="form.isNewMajor" label="0">全部</el-radio>
         <el-radio v-model="form.isNewMajor" label="1">新专业</el-radio>
         <el-radio v-model="form.isNewMajor" label="2">非新专业</el-radio>
     </el-form-item>
     <el-form-item label="层次：" v-if="false">
         <el-radio v-model="form.hasZhiJiao" label="0">全部</el-radio>
         <el-radio v-model="form.hasZhiJiao" label="1">不含本科（职业教育）</el-radio>
     </el-form-item>
  </el-form>
  <span slot="footer" class="dialog-footer" style="display: flex;align-items: center;justify-content: center;">
            <el-button type="success" @click="save">保存筛选条件</el-button>
           <el-button type="danger" @click="dialogVisible=false">取消并关闭</el-button>
  </span>
  </el-dialog>
</template>

<script>
    import { selectMajorForm, selectOneMajor, selectMajorList, screenFind, screenFindSave } from "@/api/admin/volunteer/selectMajor.js"
export default {
    data(){
        return{
            dialogVisible: false,
            loading: false,
            batch: '',
            form: {
                schooling_length: "", // 学制
                tuition_fee_min: "", // 学费最小值
                tuition_fee_max: "", // 学费最大值
                tuition_fee_no: true, // 含学费未知
                specialty_title: [], // 专业名称关键字（改为数组）
                specialty_title_other: "", // 专业名称为其他的文字
                specialty_title_no: [], // 专业名称不含关键字（改为数组）
                specialty_title_no_other: "", // 不含关键字其他
                zhengji: "",
                planned_number_min: "", // 招生计划数最小值
                planned_number_max: "", // 招生计划数最大值
                min_score: "",
                max_score: "",
                isShifan: "0", // 1师范类  2非师范类
                isNewMajor: "0", // 1新专业  2非新专业
                hasZhiJiao: "0", // 0全部 1不含本科职业教育 2不含专科高职
            },
        }
    },
    methods: {
        show() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.dialogVisible = true
                    // 这里先获取筛选的数据
                    this.aspid = this.$parent.detail.volunteer_id
                    this.screenFind(); // 获取已经选择筛选的列表
                })
            })
        },
        screenFind() {
            this.loading = true
            screenFind({
                aspid: this.aspid
            }).then(res => {
                console.log("其他筛选条件", res.data);
                if (res.data && res.data.other_screen) {
                    let other_screen = JSON.parse(res.data.other_screen);
                    console.log("其他筛选条件具体数据", other_screen);
                    
                    // 处理多选字段，将字符串转为数组
                    if (typeof other_screen.specialty_title === 'string') {
                        other_screen.specialty_title = other_screen.specialty_title 
                            ? other_screen.specialty_title.split(',') 
                            : [];
                    }
                    
                    if (typeof other_screen.specialty_title_no === 'string') {
                        other_screen.specialty_title_no = other_screen.specialty_title_no 
                            ? other_screen.specialty_title_no.split(',') 
                            : [];
                    }
                    
                    this.form = other_screen;
                    
                    if (res.data.batch) {
                        this.batch = res.data.batch;
                    }
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 处理自定义输入框中的逗号转换
        handleCustomInput(field) {
            if (this.form[field]) {
                // 将中文逗号转换为英文逗号
                this.form[field] = this.form[field].replace(/，/g, ',');
            }
        },
        save() {
            this.loading = true;
            // 深拷贝表单数据
            let form = JSON.parse(JSON.stringify(this.form));
            
            // 处理专业含有关键字：合并选择项和自定义输入
            if (Array.isArray(form.specialty_title) && form.specialty_title.length > 0) {
                let customIndex = form.specialty_title.indexOf('自定义');
                // 如果选择了自定义且有输入内容
                if (customIndex !== -1 && form.specialty_title_other) {
                    // 移除"自定义"选项
                    form.specialty_title.splice(customIndex, 1);
                    // 分割自定义输入并添加到数组
                    const customKeywords = form.specialty_title_other.split(',').map(k => k.trim());
                    form.specialty_title.push(...customKeywords);
                }
                // 转为逗号分隔的字符串
                form.specialty_title = form.specialty_title.join(',');
            }
            
            // 处理专业不含关键字：合并选择项和自定义输入
            if (Array.isArray(form.specialty_title_no) && form.specialty_title_no.length > 0) {
                let customIndex = form.specialty_title_no.indexOf('自定义');
                // 如果选择了自定义且有输入内容
                if (customIndex !== -1 && form.specialty_title_no_other) {
                    // 移除"自定义"选项
                    form.specialty_title_no.splice(customIndex, 1);
                    // 分割自定义输入并添加到数组
                    const customKeywords = form.specialty_title_no_other.split(',').map(k => k.trim());
                    form.specialty_title_no.push(...customKeywords);
                }
                // 转为逗号分隔的字符串
                form.specialty_title_no = form.specialty_title_no.join(',');
            }
            
            screenFindSave({
                aspid: this.aspid,
                name: "other_screen",
                value: JSON.stringify(form)
            }).then(() => {
                this.$notify({
                    title: '保存其他筛选条件成功',
                    message: '',
                    type: 'success'
                });
                this.dialogVisible = false;
            }).finally(() => {
                this.loading = false;
            })
        },
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/volunteer/components/selectOther.vue